import ReactDOMServer from 'react-dom/server'

export const encodeSvg = (jsx: JSX.Element): string =>
  'data:image/svg+xml,' + escape(ReactDOMServer.renderToStaticMarkup(jsx))
